/** Brief 12, the shell and the shared components. */
export const ruB12Foundation = {
  "nav.short.home": "Главная",
  "nav.short.tasks": "Задачи",
  "nav.short.conversations": "Чаты",
  "nav.short.deals": "Сделки",
  "nav.short.bronlar": "Брони",
  "nav.short.clients": "Клиенты",
  "nav.short.finance": "Финансы",
  "nav.short.reports": "Отчёты",
  "nav.short.menu": "Меню",
  "nav.aria.main": "Главное меню",
  "nav.aria.tabs": "Основные разделы",
  "shell.collapseShort": "Свернуть",
  "shell.create": "Создать",
  "shell.create.task": "Задача",
  "shell.drawer": "Меню",
  "shell.agency.switch": "Агентство и филиал",
  "shell.agency.current": "Текущее агентство",
  "shell.searchHint": "Клиент, сделка, номер брони, телефон",
  "shell.palette.searchPlaceholder": "Клиент, сделка, номер брони или телефон",
  "shell.palette.kind.section": "Раздел",
  "shell.palette.kind.client": "Клиент",
  "shell.palette.kind.deal": "Сделка",
  "shell.palette.kind.booking": "Бронь",
  "shell.palette.kind.profile": "Профиль",
  "shell.palette.searching": "Ищем",
  "shell.palette.deal": "Сделка №{id} · {name}",
  "shell.palette.booking": "Бронь {ref} · {name}",
  "shell.menu.myStatus": "Мой статус",
  "shell.menu.weekLine": "На этой неделе: продаж {count}",
  "shell.menu.myReport": "Мой отчёт",
  "shell.menu.statusNote": "В статусе «На работе» новые обращения идут вам.",
  "shell.menu.darkSidebar": "Тёмное меню",
  "shell.notifications.title": "Уведомления",
  "shell.notifications.read": "Прочитано",
  "shell.notifications.setup": "Настроить",
  "shell.notifications.group.clients": "Клиенты",
  "shell.notifications.group.operators": "Сообщения операторов",
  "shell.notifications.group.tasks": "Задачи",
  "shell.notifications.group.system": "Система",

  "ui.close": "Закрыть",
  "ui.cancel": "Отмена",
  "ui.undo": "Отменить",
  "ui.retry": "Повторить",
  "ui.denied.title": "Нет доступа",
  "ui.denied.body": "Роль «{role}» не видит этот раздел. Если нужно, напишите владельцу агентства.",
  "ui.denied.home": "На главную",
  "ui.error.title": "Не удалось загрузить",
  "ui.error.body": "Сервер не ответил. Введённые данные сохранены, страницу можно перезагрузить.",
  "ui.ai.name": "Kapitan AI",
  "ui.ai.on": "AI включён",
  "ui.ai.off": "AI выключен",
  "ui.owner": "Ответственный:",
  "ui.note.hidden": "клиент не видит",
  "ui.note.aiSees": "AI видит",
  "ui.note.meta": "Внутренняя заметка · {time}",
  "ui.draft.title": "Черновик",
  "ui.draft.waiting": "Ждёт подтверждения",
  "ui.draft.sources": "Источники ({count}) · {names}",
  "ui.draft.edit": "Изменить",
  "ui.draft.reject": "Отклонить",
  "ui.draft.send": "Отправить",
  "ui.seat.flight.ok": "В рейсе есть места",
  "ui.seat.flight.few": "В рейсе мало мест",
  "ui.seat.flight.few.count": "В рейсе мало мест ({count})",
  "ui.seat.flight.none": "В рейсе нет мест",
  "ui.seat.hotel.ok": "В отеле есть места",
  "ui.seat.hotel.few": "В отеле мало мест",
  "ui.seat.hotel.few.count": "В отеле мало мест ({count})",
  "ui.seat.stopSale": "Stop sale",
  "ui.operators.asking": "Опрашиваем операторов…",
  "ui.operators.answered": "Ответили {done} из {total} операторов",
  "ui.provider.error": "ошибка",
  "ui.close.title": "Чем закончился чат?",
  "ui.close.reason": "Причина",
  "ui.close.submit": "Закрыть",
  "ui.task.title": "Задача · {name}",
  "ui.task.type": "Тип",
  "ui.task.text": "Что нужно сделать",
  "ui.task.date": "Дата",
  "ui.task.time": "Время",
  "ui.task.note": "Заметка",
  "ui.task.notePlaceholder": "Например, просил позвонить вечером",
  "ui.task.add": "Добавить",
  "ui.route.step": "{step}/{total} · {name}",
  "ui.kpi.previous": "Прошлый период",
  "ui.loading.page": "Получаем данные",
} as const;
